import $ from 'jquery';
import { Workbox } from 'workbox-window'
import { precacheAndRoute, createHandlerBoundToURL } from 'workbox-precaching'
import { registerRoute, NavigationRoute } from 'workbox-routing'

window.jQuery = $;
window.$ = $;

/*settings*/
var FIRST_DATA = atob($('meta[name="settings"]').attr('content'));
FIRST_DATA = JSON.parse(FIRST_DATA);
window.gmap_img = FIRST_DATA.gmap_img;
window.main_color = FIRST_DATA.main_color;
window.domain_in = FIRST_DATA.domain;
window.map_center = FIRST_DATA.map_center;
window.load_after = FIRST_DATA.load_after;
window.country = FIRST_DATA.country;
window.ws_link = FIRST_DATA.ws;
window.delete_auth_confirm = FIRST_DATA.confirm.delete_auth;
window.currency = FIRST_DATA.currency;
window.min_balance = FIRST_DATA.min_balance;
window.user_balance = FIRST_DATA.user_balance;
window.user_pk = FIRST_DATA.user_pk;
window.confirm_stop_transaction = FIRST_DATA.confirm_stop_transaction;
window.check_get = false;
window.version = process.env.MIX_WEB_APP;
window.app = process.env.MIX_APP_ENV;
window.serviceWorker_url = FIRST_DATA.serviceWorker;
window.ws_source = FIRST_DATA.ws_source;
window.kW = FIRST_DATA.kW;

if ('undefined' != typeof FIRST_DATA.mapbox_api && '' != FIRST_DATA.mapbox_api) {
    window.mapbox_api = FIRST_DATA.mapbox_api;
}
if ('undefined' != typeof FIRST_DATA.can_use_apple_map) {
    window.can_use_apple_map = FIRST_DATA.can_use_apple_map;
}
if ('undefined' != typeof FIRST_DATA.apple_map_api && '' != FIRST_DATA.apple_map_api) {
    window.apple_map_api = FIRST_DATA.apple_map_api;
}

var OFFLITE_URL = FIRST_DATA.offline_url;

if ('serviceWorker' in navigator) {
    const wb = new Workbox(window.serviceWorker_url);

    precacheAndRoute([
        {
            url: OFFLITE_URL,
            revision: process.env.MIX_WEB_APP
        }
    ]);

    const handler = createHandlerBoundToURL(OFFLITE_URL);
    const navigationRoute = new NavigationRoute(handler);
    registerRoute(navigationRoute);
    wb.register();
}

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});


window.MAKE_STR_RAND = function (length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
    }
    return result;
};

window.getUrlParameter = function (sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

var utm_source = window.getUrlParameter('utm_source');
if(utm_source == 'PWA') {
    window.ws_source = 'PWA';
}
